import { ClientProfile } from '../../types';

/**
 * Cria um perfil padrão baseado nos dados do usuário autenticado
 */
export const createDefaultProfile = (user: any): ClientProfile => ({
    id: user?.id || '',
    name: user?.user_metadata?.full_name || '',
    email: user?.email || '',
    phone: '',
    website: '',
    category: 'Outros',
    logoUrl: null,
    address: {
        country: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: ''
    },
    companyName: '',
    cnpj: ''
});

/**
 * Mapeia perfil do banco para o domínio
 */
export const mapProfileFromDB = (data: any, defaultProfile: ClientProfile): ClientProfile => {
    const address = data.address || {};

    return {
        id: data.id,
        name: defaultProfile.name, // Nome pessoal (Auth)
        companyName: data.company_name || '', // Razão Social (DB)
        email: defaultProfile.email,
        phone: data.phone || '',
        website: data.website || '',
        cnpj: data.cnpj || '',
        category: 'Outros',
        logoUrl: data.logo_url,
        address: {
            country: address.country || '',
            line1: address.line1 || '',
            line2: address.line2 || '',
            city: address.city || '',
            state: address.state || '',
            zip: address.zip || ''
        }
    };
};

/**
 * Mapeia perfil do domínio para persistência
 */
export const mapProfileToDB = (user: any, profile: ClientProfile, organizationId: string) => {
    return {
        user_id: user.id,
        organization_id: organizationId,
        company_name: profile.companyName,
        cnpj: profile.cnpj,
        phone: profile.phone,
        website: profile.website,
        logo_url: profile.logoUrl,
        address: profile.address,
        updated_at: new Date().toISOString()
    };
};
